import { PrimarySideListV2 } from '@dealstack/frontend/shared/components/list/PrimarySideList/PrimarySideListV2';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import {
	Content,
	InvestmentContentWrapper,
	InvestmentHeader,
	Layout,
	MainLayout,
} from '@dealstack/frontend/investor/pages/Investment/common/investmentLayout';
import { INVESTMENT_PORTAL } from '@dealstack/frontend/investor/pages/Investment/common/renderHeaderPortal';
import { investmentJoinAndAllocationContext } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { INVESTMENT_JOIN_ROUTES } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/useInvestmentJoinAndAllocationController';
import { JoinAndAllocationChecksComplete } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationChecksComplete';
import { JoinAndAllocationPersonalDetails } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationPersonalDetails';
import { MainHeaderBar } from '@dealstack/frontend/investor/pages/Investment/common/MainHeaderBar';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { WizardStepRegistryProvider } from '@dealstack/frontend/shared/components/Wizard/WizardStepRegistry';
import { Title } from '@mantine/core';
import { Navigate, Route } from 'react-router-dom';
import { useStandaloneKycController } from './useStandaloneKycController';

export const StandaloneKyc = () => {
	const controller = useStandaloneKycController();
	const {
		contextValue,
		isLoading,
		mipName,
		activeStep,
		activeStepKey,
		onNextStep,
		onPreviousStep,
		isContinueDisabled,
		isLastStep,
		sideBarItems,
		onSidebarNavigation,
	} = controller;

	return (
		<Layout>
			{isLoading && <InlineLoader />}
			<investmentJoinAndAllocationContext.Provider value={contextValue}>
				<WizardStepRegistryProvider registry={contextValue.stepRegistry}>
					<MainHeaderBar
						title={mipName}
						activeMainStepIndex={activeStepKey}
						activeSubStepIndex={-1}
						sidebarItemsCount={sideBarItems.length}
						onPrevStep={onPreviousStep}
						isPrevDisabled={activeStepKey === 0}
						onNextStep={onNextStep}
						isNextDisabled={isContinueDisabled}
						isLastStep={isLastStep}
						redirectLink={contextValue.redirectLink}
					/>

					<MainLayout>
						<PrimarySideListV2
							sideListItems={sideBarItems}
							activeKey={activeStepKey}
							onActiveChange={onSidebarNavigation}
						/>

						<Content>
							{activeStep && (
								<InvestmentHeader>
									<Title order={5}>{activeStep.title}</Title>
									<div id={INVESTMENT_PORTAL.SECTION_HEADER} />
								</InvestmentHeader>
							)}
							<InvestmentContentWrapper>
								<SentryRoutes>
									<Route
										path={`${INVESTMENT_JOIN_ROUTES.PERSONAL_DETAILS}/*`}
										element={<JoinAndAllocationPersonalDetails />}
									/>
									<Route
										path={`${INVESTMENT_JOIN_ROUTES.CHECKS_COMPLETE}/*`}
										element={<JoinAndAllocationChecksComplete />}
									/>
									<Route
										index
										element={
											<Navigate
												to={`.${INVESTMENT_JOIN_ROUTES.CHECKS_COMPLETE}/instructions`}
												relative="path"
											/>
										}
									/>
								</SentryRoutes>
							</InvestmentContentWrapper>
						</Content>
					</MainLayout>
				</WizardStepRegistryProvider>
			</investmentJoinAndAllocationContext.Provider>
		</Layout>
	);
};
